import { API_BASE_URL } from "@/config/apiBase";

let webConfigLoaded = false;
let loadPromise = null;

const LOAD_TIMEOUT_MS = 3000;

/**
 * Load Firebase / Google web config from backend (backend/.env → GET /api/config/web).
 * Local dev: testOpsHub/.env is used until this succeeds. Non-blocking if API is down.
 */
export function ensureWebConfigLoaded() {
  if (typeof window === "undefined") return Promise.resolve();
  if (webConfigLoaded) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    const apiRoot = API_BASE_URL || "";
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), LOAD_TIMEOUT_MS);
    try {
      const res = await fetch(`${apiRoot}/api/config/web`, {
        credentials: "same-origin",
        signal: controller.signal,
      });
      if (!res.ok) return;
      const data = await res.json();
      if (!data || typeof data !== "object") return;

      const fb = data.firebase || {};
      const patch = {};
      if (fb.apiKey) patch.VUE_APP_FIREBASE_API_KEY = fb.apiKey;
      if (fb.authDomain) patch.VUE_APP_FIREBASE_AUTH_DOMAIN = fb.authDomain;
      if (fb.projectId) patch.VUE_APP_FIREBASE_PROJECT_ID = fb.projectId;
      if (fb.storageBucket) patch.VUE_APP_FIREBASE_STORAGE_BUCKET = fb.storageBucket;
      if (fb.messagingSenderId) patch.VUE_APP_FIREBASE_MESSAGING_SENDER_ID = fb.messagingSenderId;
      if (fb.appId) patch.VUE_APP_FIREBASE_APP_ID = fb.appId;
      if (data.googleClientId) patch.VUE_APP_GOOGLE_CLIENT_ID = data.googleClientId;

      if (Object.keys(patch).length > 0) {
        const base = window.ENV && typeof window.ENV === "object" ? window.ENV : {};
        window.ENV = { ...base, ...patch };
      }
    } catch (_err) {
      // Backend offline or timeout — .env / env-config.js still apply via vueEnv().
    } finally {
      clearTimeout(timer);
      webConfigLoaded = true;
    }
  })();

  return loadPromise;
}

/** Reset in-memory web config cache (e.g. after logout). */
export function resetWebConfigCache() {
  webConfigLoaded = false;
  loadPromise = null;
}
